import Api from 'core/services/api'
import { FindProductsByIdRequest, FindProductsByEANRequest } from 'core/services/models'

const path = '/v1/catalogs'

export const findByEan = ({ ean }: FindProductsByEANRequest) => {
  return Api.request({
    url: `${path}?search=${ean}`,
  })
}

export const findByMatchId = ({ matchId }: FindProductsByIdRequest) => {
  return Api.request({
    url: `${path}?id=${matchId}`,
  })
}
